export interface CurriculumReference {
  id: string;
  title: string;
  publisher: string;
  url: string;
  use: string;
  lastReviewed: string;
}

export const curriculumReferences: readonly CurriculumReference[] = [
  {
    id: "qm-higher-ed-rubric-7",
    title: "Higher Education Rubric, Seventh Edition",
    publisher: "Quality Matters",
    url: "https://www.qualitymatters.org/qa-resources/rubric-standards/higher-ed-rubric",
    use: "Constructive alignment among objectives, assessment, materials, activities, and technology.",
    lastReviewed: "2026-08-10",
  },
  {
    id: "suny-oscqr",
    title: "OSCQR SUNY Online Course Quality Review Rubric",
    publisher: "SUNY Online",
    url: "https://oscqr.suny.edu/",
    use: "Online-course review, authentic assessment, interaction, feedback, support, and accessibility.",
    lastReviewed: "2026-08-10",
  },
  {
    id: "ecfr-34-600-2",
    title: "34 CFR § 600.2 — Definitions",
    publisher: "U.S. Government Publishing Office, eCFR",
    url: "https://www.ecfr.gov/current/title-34/subtitle-B/chapter-VI/part-600/subpart-A/section-600.2",
    use: "Reference definitions for credit hour, distance education, and regular and substantive interaction; not a claim of institutional compliance.",
    lastReviewed: "2026-08-10",
  },
  {
    id: "wcag-2-2",
    title: "Web Content Accessibility Guidelines (WCAG) 2.2",
    publisher: "World Wide Web Consortium",
    url: "https://www.w3.org/TR/WCAG22/",
    use: "Testable accessibility requirements for learner-facing web content and interactions.",
    lastReviewed: "2026-08-10",
  },
  {
    id: "cast-udl-3",
    title: "Universal Design for Learning Guidelines 3.0",
    publisher: "CAST",
    url: "https://udlguidelines.cast.org/",
    use: "Equivalent ways to access learning, sustain engagement, and demonstrate competence.",
    lastReviewed: "2026-08-10",
  },
  {
    id: "intercom-rice",
    title: "RICE: Simple prioritization for product managers",
    publisher: "Intercom",
    url: "https://www.intercom.com/blog/rice-simple-prioritization-for-product-managers/",
    use: "Origin, equation, example scales, and limitations of the RICE prioritization model.",
    lastReviewed: "2026-08-10",
  },
  {
    id: "nist-ai-rmf-1",
    title: "Artificial Intelligence Risk Management Framework (AI RMF 1.0)",
    publisher: "National Institute of Standards and Technology",
    url: "https://doi.org/10.6028/NIST.AI.100-1",
    use: "Govern, Map, Measure, and Manage functions and trustworthy AI characteristics.",
    lastReviewed: "2026-08-10",
  },
  {
    id: "nist-genai-profile",
    title: "Artificial Intelligence Risk Management Framework: Generative Artificial Intelligence Profile",
    publisher: "National Institute of Standards and Technology",
    url: "https://doi.org/10.6028/NIST.AI.600-1",
    use: "Generative-AI-specific risks and risk-management actions.",
    lastReviewed: "2026-08-10",
  },
  {
    id: "nist-privacy-framework",
    title: "NIST Privacy Framework",
    publisher: "National Institute of Standards and Technology",
    url: "https://www.nist.gov/privacy-framework",
    use: "Data processing, privacy risk, governance, and control selection.",
    lastReviewed: "2026-08-10",
  },
  {
    id: "usco-ai",
    title: "Copyright and Artificial Intelligence",
    publisher: "U.S. Copyright Office",
    url: "https://www.copyright.gov/ai/",
    use: "Current U.S. Copyright Office reports and guidance related to AI and copyright.",
    lastReviewed: "2026-08-10",
  },
] as const;

const referencesById = new Map(curriculumReferences.map((reference) => [reference.id, reference]));

export const getCurriculumReferences = (ids: readonly string[]): CurriculumReference[] =>
  ids.map((id) => {
    const reference = referencesById.get(id);
    if (!reference) throw new Error(`Unknown curriculum reference: ${id}`);
    return reference;
  });
